import { Outlet } from 'react-router-dom';
import { PushOptInDialog } from '../../features/notifications/components/push-opt-in-dialog';
import { PushRegistration } from '../../features/notifications/components/push-registration';
import { OnboardingTourProvider } from '../../features/onboarding/onboarding-tour-provider';
import { AppLayout } from '../../shell/app-layout';

export function AuthenticatedLayout() {
  return (
    <OnboardingTourProvider>
      <AppLayout>
        <PushRegistration />
        <PushOptInDialog />
        <div className="lp-page min-h-full">
          <Outlet />
        </div>
      </AppLayout>
    </OnboardingTourProvider>
  );
}
